<template>
  <router-view />
</template>

<script>
export default {
  name: 'OperationsWorkshop',
  data() {
    return {
    };
  },
};
</script>
